export const INTERCOM_API_BASE = 'https://api-iam.intercom.io';
